"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Jan Prokop
 */


var NChangedWinPriceValidityConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NChangedWinPriceValidityConverter, _NotificationDocConve);

  function NChangedWinPriceValidityConverter() {
    _classCallCheck(this, NChangedWinPriceValidityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinPriceValidityConverter).apply(this, arguments));
  }

  return NChangedWinPriceValidityConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NChangedWinPriceValidityConverter = NChangedWinPriceValidityConverter;